import { useEffect, useState } from "react";
import { useSakhadSendOtp } from "../../../hook/request/providerSakhad";
import { markSakhadOtpSent } from "../../../utils/OtpRateLimitSakhad";
import SakhadOtpModal from "../visits/SakhadOtpModal";
import { connect } from "react-redux";
import { general } from "../../../store/action";
import SakhadLoginModal from "../visits/SakhadLoginModal";
import { useCheckInsurance } from "../../../hook/request/visit/visits";
import {
  useGetAllINsurers,
  useGetProviderInsurer,
} from "../../../hook/request/setting";
import { SakhadVerifyCaptchaInitData } from "../../../types/sakhadAuth";
import SakhadVerifyCaptchaModal from "../visits/SakhadVerifyCaptchaModal";

type CheckSakhadStatusProp = {
  handleShowModal: (modalName: string, config: any) => void;
};

// const getInsurers = useGetAllINsurers();
// const [insurersData, setInsurersData] =useState([]);

// useEffect(() => {
//   if (getInsurers?.data?.data?.result) {
//     const data = getInsurers.data.data.result;
//     setInsurersData(data);
//   }
// }, [getInsurers.data]);

const CheckSakhadStatus = ({ handleShowModal }: CheckSakhadStatusProp) => {
  const sakhasSendOtp = useSakhadSendOtp();

  // 1. TRIGGER: This runs immediately when the component mounts
  useEffect(() => {
    sakhasSendOtp.mutate(undefined);
  }, []); // Empty array ensures it runs only once

  // 2. LOGIC: This runs when the mutation finishes
  useEffect(() => {
    if (!sakhasSendOtp.isSuccess) return;

    const responseData = sakhasSendOtp.data;

    // A. Check if user is already logged in (Skipped API call)
    if (responseData && "isSkipped" in responseData) {
      if (responseData.isSkipped) {
        // User is logged in, do nothing (no modal needed)
        return;
      }
    }

    // B. Check the API response if it wasn't skipped
    if (responseData && "data" in responseData) {
      const result = responseData.data?.result;
      if (!result) return;

      const { captcha, sessionId, requestId } = result;

      if (captcha && sessionId) {
        // Logic requires Login (Username/Password/Captcha)
        handleShowModal("sakhadLoginModal", { data: result });
        markSakhadOtpSent();
      } else if (requestId) {
        // Logic requires OTP (One Time Password)
        handleShowModal("sakhadOtpModal", { data: result });
      }
    }
  }, [sakhasSendOtp.isSuccess, sakhasSendOtp.data, handleShowModal]);

  return (
    <>
      <SakhadOtpModal />
      <SakhadLoginModal />
      <SakhadVerifyCaptchaModal />
    </>
  );
};

const mapDispatchToProps = (dispatch: any) => ({
  handleShowModal: (data: any, body: any) =>
    dispatch(general.handleShowModal(data, body)),
});

export default connect(null, mapDispatchToProps)(CheckSakhadStatus);
